module.exports = __webpack_public_path__ + "static/media/face5.e167e6dc.jpg";